import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FontAwesomeIcons } from 'src/app/constants/icons';

@Component({
    templateUrl: './icon-dialog.component.html',
    styleUrls: ['./icon-dialog.component.css'],
    standalone: false
})
export class IconDialogComponent {
  searchQuery: string = '';
  icons: { name: string, label: string }[] = FontAwesomeIcons;
  selectedIcon: { name: string, label: string } = null;


  constructor(public dialogRef: MatDialogRef<IconDialogComponent>) {
    
  }

  get filteredIcons() {
    return this.icons.filter(icon =>
      icon.label.toLowerCase().includes(this.searchQuery.toLowerCase()) || icon.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }
}